var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "login-container" },
    [
      _c(
        "el-form",
        {
          ref: "loginForm",
          staticClass: "login-form",
          attrs: { "label-width": "150px", model: _vm.loginForm },
        },
        [
          _c("div", { staticClass: "login-error" }, [
            _vm._v(_vm._s(this.error)),
          ]),
          _c(
            "el-form-item",
            { attrs: { prop: "loginName", label: "账号" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.loginForm.loginName,
                  callback: function ($$v) {
                    _vm.$set(_vm.loginForm, "loginName", $$v)
                  },
                  expression: "loginForm.loginName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "password", label: "密码" } },
            [
              _c("el-input", {
                attrs: { type: "password" },
                model: {
                  value: _vm.loginForm.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.loginForm, "password", $$v)
                  },
                  expression: "loginForm.password",
                },
              }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticStyle: { width: "100%" },
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.login },
            },
            [_vm._v(" 登录 ")]
          ),
          _c(
            "div",
            { staticClass: "login-info" },
            [
              _vm._v(" 如果没有册账号请"),
              _c("router-link", { attrs: { to: "/user/register" } }, [
                _vm._v(" 点击注册 "),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }